// extracted by mini-css-extract-plugin
export var alignCenter = "_8c-d";
export var bannerShown = "_8c-6";
export var buttonContent = "_8c-0";
export var cardList = "_8c-1";
export var centerContent = "_8c-2";
export var chevron = "_8c-3";
export var closePanelButton = "_8c-k";
export var conversationContextContainer = "_8c-l";
export var conversationDetailContainer = "_8c-4";
export var detailWrapper = "_8c-7";
export var dropdownButton = "_8c-e";
export var dropdownTitle = "_8c-9";
export var fullHeight = "_8c-5";
export var hidden = "_8c-a";
export var icon = "_8c-b";
export var mergeSuggestionWrapper = "_8c-m";
export var panel = "_8c-i";
export var portalButtonsWrapper = "_8c-c";
export var right = "_8c-j";
export var tableSummaryContainer = "_8c-8";
export var tableSummaryHeader = "_8c-g";
export var threeDotsButton = "_8c-f";
export var wide = "_8c-h";